






import Vue from 'vue';
import BaseButton from './BaseButton.vue';
import LogoutIcon from '../../../assets/img/logout.svg';

export default Vue.extend({
    components: { BaseButton, LogoutIcon },
    props: {
        label: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'big',
        },
        title: {
            type: String,
            default: '',
        },
        type: {
            type: String,
            default: 'button',
        },
    },
});
